import React from 'react';
import PropTypes from 'prop-types';


class PaginationBar extends React.Component {
  changePage = (page) => {
    if (this.props.changePage) this.props.changePage(page);
  }
  render() {
    const { currentPage, total } = this.props;
    if (total === 1) return null;

    let prev = null;
    let next = null;

    if (currentPage > 1) {
      prev = (
        <li className="pagination_prev control">
          <a onClick={() => this.changePage(currentPage - 1)}>Previous</a>
        </li>
      );
    }

    if (currentPage !== total) {
      next = (
        <li className="pagination_next control">
          <a onClick={() => this.changePage(currentPage + 1)}>Next</a>
        </li>
      );
    }

    const pages = [];

    let softTotal = 5;
    let startPage = 1;

    if (total <= softTotal) softTotal = total;
    if (total >= softTotal) {
      if (currentPage < 5) {
        startPage = 1;
      } else {
        startPage = currentPage - 3;
        softTotal = startPage + 5;
        if (softTotal >= total) softTotal = total;
      }
    }

    for (let page = startPage; page <= softTotal; page++) {
      pages.push(<li key={`pag-${page}`} className={page === currentPage ? 'active' : ''}><a onClick={() => this.changePage(page)}>{page}</a></li>);
    }

    return (
      <div className="cb-blog_bar">
        <div className="cb-blog_pagination">
          <div className="pagination">
            <ul className="pagination">
              {prev}
              {pages}
              {next}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

PaginationBar.propTypes = {
  changePage: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
};

export default PaginationBar;



// WEBPACK FOOTER //
// ./src/Components/Dashboard/Modules/PaginationBar.jsx